import {useContext} from 'react';

import {PapersContext} from '../contexts';

export const usePapers = () => {
  return useContext(PapersContext);
};
